import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import CreateAdModal from './CreateAdModal'; // Your existing modal for creating 
import AdCard from '../AdCard';
import './AdsTab.css'; // The new CSS file for styling

const AdsTab = ({ adsData, onDataRefresh }) => {
    const { currentUser } = useAuth();
    const { firebaseUser } = useAuth(); 
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [previewAd, setPreviewAd] = useState(null);

    // // State for the AI generator
    // const [aiPrompt, setAiPrompt] = useState({ product: '', location: '', details: '', contact: '' });
    // const [generatedAdText, setGeneratedAdText] = useState(null); // Will store { title, description }
    // const [isGenerating, setIsGenerating] = useState(false);

    // const handleGenerateAd = async (e) => {
    //     e.preventDefault();
    //     setIsGenerating(true);
    //     setGeneratedAdText(null);
    //     try {
    //         const idToken = await currentUser.getIdToken(true);
    //         const response = await axios.post(
    //             'https://api-5iacy4tfya-uc.a.run.app/admin/generate-ad-with-ai',
    //             aiPrompt,
    //             { headers: { Authorization: `Bearer ${idToken}` } }
    //         );
    //         setGeneratedAdText(response.data); // Save the AI's generated text
    //     } catch (error) {
    //         console.error("AI Ad Generation Failed:", error);
    //         alert("AI generation failed. The server may be busy or misconfigured.");
    //     } finally {
    //         setIsGenerating(false);
    //     }
    // };

    const handleDelete = async (adId) => {
        if (!firebaseUser) return;
        if (window.confirm("Are you sure you want to delete this ad?")) {
            try {
                const idToken = await firebaseUser.getIdToken(true);
                // Ensure this matches your DELETE endpoint in the backend
                await axios.delete(`https://api-5iacy4tfya-uc.a.run.app/admin/ads/${adId}`, { 
                    headers: { Authorization: `Bearer ${idToken}` } 
                });
                onDataRefresh();
                alert("Ad deleted successfully.");
            } catch (error) {
                console.error("Error deleting ad:", error);
                alert(error.response?.data?.message || "Failed to delete ad.");
            }
        }
    };

    // SEARCH FILTER
    const filteredAds = adsData.filter(ad => {
        const s = searchTerm.toLowerCase();
        return ad.title?.toLowerCase().includes(s) || ad.sponsor?.toLowerCase().includes(s);
    });

    return (
        <div>
            {/* --- AI AD GENERATOR SECTION --- */}
            {/* <div className="ai-ad-generator-card">
                <h3>Generate Ad with AI</h3>
                <form onSubmit={handleGenerateAd} className="ai-ad-form">
                    <input required type="text" placeholder="Product or Service Name (e.g., Saree Shop)" onChange={e => setAiPrompt({ ...aiPrompt, product: e.target.value })} />
                    <input type="text" placeholder="Location (Optional, e.g., Hyderabad)" onChange={e => setAiPrompt({ ...aiPrompt, location: e.target.value })} />
                    <textarea required placeholder="Key Details (e.g., Diwali sale, 50% off on all silk sarees)" onChange={e => setAiPrompt({ ...aiPrompt, details: e.target.value })} />
                    <input type="text" placeholder="Contact Info (Optional, e.g., Call 999...)" onChange={e => setAiPrompt({ ...aiPrompt, contact: e.target.value })} />
                    <button type="submit" className="generate-btn" disabled={isGenerating}>
                        {isGenerating ? 'Generating...' : '✨ Generate Ad Copy'}
                    </button>
                </form>

                {generatedAdText && (
                    <div className="generated-ad-preview">
                        <h4>AI Generated Preview</h4>
                        <h5>{generatedAdText.title}</h5>
                        <p>{generatedAdText.description}</p>
                        <button className="approve-btn" onClick={() => setShowCreateModal(true)}>
                            + Use This Text & Create Ad
                        </button>
                    </div>
                )}
            </div> */}

            {/* --- EXISTING AD MANAGEMENT SECTION --- */}
            <div className="admin-tab-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h3>Manage Existing Advertisements</h3>
                <input 
                    type="text" 
                    placeholder="Search Ads or Sponsors..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="admin-search-input"
                />
                {/* <button className="create-btn" onClick={() => { setGeneratedAdText(null); setShowCreateModal(true); }}>+ Create Manually</button> */}
            </div>
            <div className="table-wrapper">
                {/* ... Your existing table for displaying ads ... */}
                <table className="news-table">
  <thead>
    <tr>
      <th>Preview</th>
      <th>Title & Type</th>
      <th>Sponsor / User Info</th>
      <th>Link</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {filteredAds.map(ad => {  // <--- Added opening brace '{'
    // Logic to determine thumbnail
    const isVideoAd = ad.mediaType === 'video' || ad.videoUrl;
    const previewThumb = isVideoAd ? ad.videoUrl : (ad.imageUrls?.[0] || ad.imageUrl);

    return (
      <tr key={ad.id}>
    <td 
        onClick={() => setPreviewAd(ad)} 
        style={{ cursor: 'pointer', textAlign: 'center' }}
        title="Click to see full ad preview"
    >
        <div className="ad-preview-container" style={{ width: '80px', height: '100px', background: '#000', overflow: 'hidden', margin: '0 auto', borderRadius: '4px' }}>
            {ad.videoUrl ? (
                <video 
                    src={`${ad.videoUrl}#t=0.001`} 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                    muted 
                    playsInline
                    preload="metadata"
                />
            ) : (
                <img 
                    src={ad.imageUrls?.[0] || ad.imageUrl} 
                    alt="Ad Preview" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                />
            )}
        </div>
        <div style={{ fontSize: '10px', marginTop: '4px', color: '#007bff' }}>🔍 Preview</div>
    </td>
        <td>
          <div style={{fontWeight: 'bold'}}>{ad.title}</div>
          <div style={{fontSize: '11px', color: isVideoAd ? '#1976d2' : '#666'}}>
            {isVideoAd ? '📹 Video Ad' : '🖼️ Image Ad'}
          </div>
        </td>
        <td style={{fontSize: '12px'}}>
          <strong>Name:</strong> {ad.userName || ad.sponsor}<br/>
          <strong>Email:</strong> {ad.userEmail}<br/>
          <strong>Phone:</strong> {ad.userPhone || 'N/A'}
        </td>
        <td><a href={ad.link} target="_blank" rel="noreferrer">Link</a></td>
        <td>
          <button className="delete-btn" onClick={() => handleDelete(ad.id)}>Delete</button>
        </td>
      </tr>
    );
})}
  </tbody>
</table>
            </div>

            {/* The existing modal is now smarter. It receives the AI text as initial data. */}
            {showCreateModal && (
                <CreateAdModal
                    // initialData={generatedAdText} // Pass AI-generated text to the modal
                    onClose={() => setShowCreateModal(false)}
                    onAdCreated={() => {
                        setShowCreateModal(false); // Close modal on success
                        // setGeneratedAdText(null);   // Clear the preview
                        onDataRefresh();          // Refresh the list of ads
                    }}
                />
            )}
            {/* --- FULL AD PREVIEW MODAL (matches Profile) --- */}
            {previewAd && ReactDOM.createPortal(
                <div className="modal-overlay" onClick={() => setPreviewAd(null)} style={{ zIndex: 10000 }}>
                    <div className="modal-content" onClick={e => e.stopPropagation()} style={{ background: 'transparent', boxShadow: 'none', width: '95%', maxWidth: '450px', position: 'relative' }}>
                        
                        {/* Close Button */}
                        <button 
                            onClick={() => setPreviewAd(null)} 
                            style={{ 
                                position: 'absolute', top: '-40px', right: '0', 
                                background: 'none', border: 'none', color: 'white', 
                                fontSize: '35px', cursor: 'pointer' 
                            }}
                        >
                            &times;
                        </button>

                        {/* Rendering the actual AdCard component */}
                        <AdCard adData={previewAd} />
                        
                        <div style={{ color: 'white', textAlign: 'center', marginTop: '15px', fontWeight: 'bold' }}>
                            Full Live Preview (How users see it)
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};
export default AdsTab;